import React from "react";
import TooltipCustomTable from "../tooltipCustomTable";
import "./style.scss";

const CustomTooltipWrapper = (props) => {
  const { value } = props;
  return (
    <TooltipCustomTable title={value} field={props?.field} arrow>
      <div className="ellipsis">{value}</div>
    </TooltipCustomTable>
  );
};

const areEqual = (prevProps, nextProps) => {
  return prevProps.value === nextProps.value;
};

export default React.memo(CustomTooltipWrapper, areEqual);
